<template>
    <div>

        <form>

        <label for="ide">IDE</label>
        <input type="number" ide="ide" v-model="ide"  @focus="$emit('ajustaposicaoteclado', 'ide');">

        <label for="filia">Filial</label>
        <input type="number" id="filial" v-model="filial"  @focus="$emit('ajustaposicaoteclado', 'filial');">

        <label for="login">Login</label>
        <input type="text" id="login" v-model="login"  @focus="$emit('ajustaposicaoteclado', 'login');">

        <label for="senha">Senha</label>
        <input type="password" id="senha" v-model="senha"  @focus="$emit('ajustaposicaoteclado', 'senha');">

        <input type="submit" value="login" @click="dologin" >


        </form>
        <!--
            <div class="div-linha-form">
                <div class="div-label-form">IDE</div>
                <div class="div-campo-form"><input type="number" @focus="$emit('ajustaposicaoteclado', '');"  placeholder="" v-model="ide"></div>
            </div>

            <div class="div-linha-form">
                <div class="div-label-form">Filial</div>
                <div class="div-campo-form"><input type="number" @focus="$emit('ajustaposicaoteclado', '');"  placeholder="" v-model="filial"></div>
            </div>

            <div class="div-linha-form">
                <div class="div-label-form">Login</div>
                <div class="div-campo-form"><input type="text" @focus="$emit('ajustaposicaoteclado', 'login');" 
                    placeholder="" v-model="login"></div>
            </div>

            <div class="div-linha-form">
                <div class="div-label-form">Senha</div>
                <div class="div-campo-form"><input type="password" @focus="$emit('ajustaposicaoteclado', 'senha');" placeholder="" v-model="senha"></div>
            </div>

            <div class="div-linha-form">
                <center>
                    <input type="button" value="login" @click="dologin" @focus="$emit('ajustaposicaoteclado', '');">
                </center>
            </div>
        -->

    </div>
</template>

<script>
import request from '@/services/services.js';

export default {
    name : 'FormLogin',
    data() {
        return {
            ide: '',
            filial: '',
            login: '',
            senha: ''
        };        
    },
    props : ["telainicio"],
    mounted(){

        if(this.$root.getIde()!==0)
        this.ide = this.$root.getIde();

        this.login = this.$root.getLogin();

        if(this.$root.getFilial()!==0)
        this.filial = this.$root.getFilial();
    },

    methods: {
        dologin(event){            

            if (event) {
                event.preventDefault();
            }

            request(this, 'POST',
                    'Mobile_DoLogin',
                    `login=${this.login}&senha=${this.senha}&filial=${this.filial}&ide=${this.ide}`)
                .then(res => {
                    if(res){

                        if((res.id_sessao)&&(res.id_usuario)){

                            this.$root.setLogin(this.login);
                            this.$root.setIde(this.ide);
                            this.$root.setFilial(this.filial);

                            this.$root.setSessao(res.id_sessao);
                            this.$root.setUsuario(res.id_usuario);

                            this.$root.setSessaoExpirada(false);

                            if(this.telainicio)
                            this.$router.push(`/cadastros`);
                        }
                    }
                });


        }
    }
}
</script>

<style scoped>

    input, label{
        display: block;
    }

    label{
        margin-left: 10%;
    }
    
    .div-linha-form{
        width: calc(100% - 40px);
        display: table;
        margin: 10px 20px;
    }

    .div-label-form{
        float: left;
        width: calc(30%);
        line-height: 30px;
        height: 30px;
        font-weight: bold;
        
    }

    .div-campo-form{
        float: left;
        width: calc(70% - 30px);
    }
	
	input[type=text]:focus, input[type=number]:focus, input[type=password]:focus, input[type=button]:focus{
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);	
		transition: all  0.2s ease-in-out;
		outline: none;
		border: 1px solid #428bca;
        
	}
	
	input[type=text], input[type=number], input[type=password]{
		font-size: 14px;
		border-radius: 5px;
		border: 1px solid #dedede;
		padding: 8px;
		width: calc(80% - 16px);
        margin: 2px 10% 10px;		
		transition: all  0.2s ease-in-out;		
	}
	
	input[type=submit]{

        font-size: 16px;
        background-color: var(--primary-color);
        border: 0px;
        transition: all  0.2s ease-in-out;		
        padding: 5px;
        width: calc(80% - 30px);
        color: #FFFFFF;
        height: 40px;
        --box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        margin: 20px auto;

        border-radius: 4px;


		background-color: #6ca00c;
	}
</style>